<template>
<div>
    <ShowAllOrders orderStatus="unsigned"></ShowAllOrders>
</div>
</template>

<script>
import ShowAllOrders from '@/components/App/dashboard/ShowAllOrders.vue';
export default {
    name: "PartnerNationUnsignedTab",
    components: {
        ShowAllOrders
    }
}
</script>

<style>
</style>